module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/column-square/square_column.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/column-square/square_column.png
// module id = 544
// module chunks = 0